module.exports = __webpack_public_path__ + "assets/images/slope-religion/tablet.svg?v=d94b8f57";